import React, { useState, useEffect } from 'react';
import { List, Typography, Tooltip, Badge } from 'antd';
import { RightOutlined, ClockCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroller';
import './index.less';
import { adminMessageListApi, adminDownloadedApi } from '@service';

const { Link } = Typography;

export default props => {
  const { type = 0, newData = [] } = props;
  const text_max = 25;

  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const getAdminMessage = async page_index => {
    const {
      flag,
      data: { list },
    } = await adminMessageListApi({ type, page_index });

    if (flag === 200) {
      if (list.length === 0) {
        setHasMore(false);
        return;
      }
      setListData(prev => [...prev, ...list]);
    }
  };

  useEffect(() => {
    getAdminMessage(1);
  }, []);

  useEffect(() => {
    setListData(prev => [...newData, ...prev]);
  }, [newData]);

  const onLoadMore = page => {
    setLoading(true);
    getAdminMessage(page);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const downloaded = async (item, e) => {
    let { flag } = await adminDownloadedApi({ url: encodeURIComponent(item.url) });

    if (flag === 200) {
      location.reload([true])
    } else {
      e.preventDefault();
    }
  };

  return (
    <div className="drawer-box">
      <InfiniteScroll
        initialLoad={false}
        pageStart={1}
        loadMore={onLoadMore}
        hasMore={!loading && hasMore}
        useWindow={false}
      >
        <List
          size="small"
          dataSource={listData}
          renderItem={item => (
            <List.Item>
              <div className="em-18">
                {item.content.length > text_max && (
                  <Tooltip title={item.content}>
                    <div className="task-title">
                      <Badge dot={item.read !== '1'} offset={[-10, 0]} />
                      {item.content.slice(0, text_max)}...
                    </div>
                  </Tooltip>
                )}
                {item.content.length <= text_max && (
                  <div className="task-title">
                    <Badge dot={item.read !== '1'} offset={[-10, 0]} />
                    {item.content}
                  </div>
                )}
                <div className="task-time">
                  <ClockCircleOutlined />
                  &nbsp;&nbsp;{item.time}
                </div>
              </div>
              <div className="em-6">
                <Link href={item.url} target={type === 2 ? '_blank' : '_self'} onClick={(e) => downloaded(item, e)}>
                  {type === 2 && <DownloadOutlined style={{ fontSize: 22 }} />}
                  {type === 1 && (
                    <>
                      前往处理
                      <RightOutlined />
                    </>
                  )}
                </Link>
              </div>
            </List.Item>
          )}
        />
      </InfiniteScroll>
      {!hasMore && listData.length ? <p className="no-more-tip">暂无更多咯~</p> : ''}
    </div>
  );
};
